import { useEffect, useRef, useState } from 'react';
import { animate, useReducedMotion } from 'framer-motion';
/** Counts up to `target` when it arrives or changes — a quick flourish for totals. */
export function useCountUp(target, duration = 0.7) {
    const reduce = useReducedMotion();
    const [shown, setShown] = useState(0);
    const from = useRef(0);
    useEffect(() => {
        if (target == null)
            return;
        if (reduce) {
            setShown(target);
            from.current = target;
            return;
        }
        const controls = animate(from.current, target, {
            duration,
            ease: [0.2, 0.8, 0.2, 1],
            onUpdate: (v) => setShown(Math.round(v)),
        });
        from.current = target;
        return () => controls.stop();
    }, [target, duration, reduce]);
    return target == null ? undefined : shown;
}
